import { render, staticRenderFns } from "./othersDialog.vue?vue&type=template&id=106db315&"
import script from "./othersDialog.vue?vue&type=script&lang=js&"
export * from "./othersDialog.vue?vue&type=script&lang=js&"
import style0 from "./othersDialog.vue?vue&type=style&index=0&id=106db315&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports